import { createRouter, createWebHashHistory } from "vue-router";
import localCache from '@/utils/cache'

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    component: () => import("@/views/login/Login.vue"),
  },
  {
    path: "/home",
    name: "home",
    redirect: "/workbench",
    component: () => import("@/views/home/Home.vue"),
    children: [
      // {
      //   path: "/dataScreen",
      //   name: "dataScreen",
      //   component: () => import("@/views/dataScreen/index.vue")
      // },
      // 工作台
      {
        path: "/workbench",
        name: "workbench",
        component: () => import("@/views/workbench/Workbench.vue")
      },
      {
        path: "/monitor",
        name: "monitor",
        component: () => import("@/views/monitor/Monitor.vue"),
        children: [
          {
            path: "",
            name: "baseList",
            redirect: "/monitor/baseList",
          },
          {
            path: "baseList",
            component: () => import("@/views/monitor/cpns/baseContent/BaseContent.vue"),
          },
          {
            path: "weatherService",
            component: () => import("@/views/monitor/cpns/weatherServiceContent/WeatherServiceContent.vue"),
          }
        ]
      },
      {
        path: "/dataManagement",
        name: "dataManagement",
        component: () => import("@/views/dataManagement/index.vue"),
        redirect: '/dataManagement/aircraft',
        children: [
          {
            path: "/dataManagement/facility",
            label: '设施设备管理',
            redirect: '/dataManagement/facility/facilityType',
            component: () => import("@/views/dataManagement/index.vue"),
            children: [
              {
                path: "/dataManagement/facility/facilityType",
                label: '设施设备类型管理',
                component: () => import("@/views/dataManagement/index.vue"),
                meta: {
                  keepAlive: true
                }
              },
              {
                path: "/dataManagement/facility/facilityData",
                label: '设施设备数据管理',
                component: () => import("@/views/dataManagement/index.vue"),
                meta: {
                  keepAlive: true
                }
              },
            ]
          },
          
          {
            path: "/dataManagement/groundResources",
            label: '地面资源类型管理',
            component: () => import("@/views/dataManagement/index.vue"),
            redirect: '/dataManagement/groundResources/groundResourcesType',
            children: [
              {
                path: "/dataManagement/groundResources/groundResourcesType",
                label: '地面资源类型管理',
                component: () => import("@/views/dataManagement/index.vue"),
              },
              {
                path: "/dataManagement/groundResources/groundResourcesData",
                label: '地面资源数据管理',
                component: () => import("@/views/dataManagement/index.vue"),
              },
            ]
          },
          {
            path: "/dataManagement/aircraft",
            label: '飞行器管理',
            component: () => import("@/views/dataManagement/index.vue"),
            children: [
              {
                path: "/dataManagement/aircraft/dataDetail",
                label: '飞行器数据详情',
                component: () => import("@/views/dataManagement/index.vue"),
              },
            ]
          }
        ]
      },
      {
        path: "/flightPlan",
        name: "flightPlan",
        component: () => import("@/views/flightPlan/index.vue"),
        redirect: '/flightPlan/management',
        children: [
          {
            path: "/flightPlan/declaration",
            label: '飞行计划申报',
            component: () => import("@/views/flightPlan/index.vue"),
          },
          {
            path: "/flightPlan/alteration",
            label: '飞行计划变更',
            component: () => import("@/views/flightPlan/index.vue"),
          },
          {
            path: "/flightPlan/accraditation",
            label: '飞行计划审批',
            component: () => import("@/views/flightPlan/index.vue"),
          },
          {
            path: "/flightPlan/management",
            label: '飞行任务管理',
            component: () => import("@/views/flightPlan/index.vue"),
          },
          {
            path: "/flightPlan/management/newFlightPlane",
            label: '新增飞行计划',
            component: () => import("@/views/flightPlan/index.vue"),
          },
          {
            path: "/flightPlan/management/planDetails",
            label: '飞行计划详情',
            component: () => import("@/components/flightPlan/planDetails.vue"),
          },
        ]
      },
      {
        path: "/flightSchedule",
        name: "flightSchedule",
        component: () => import("@/views/flightSchedule/index.vue"),
        redirect: '/flightSchedule/airspace',
        children: [
          {
            path: "/flightSchedule/airspace",
            label: '空域管理',
            component: () => import("@/views/flightSchedule/index.vue"),
          },
          {
            path: "/flightSchedule/airApproachControl",
            label: '航线管理',
            component: () => import("@/views/flightSchedule/index.vue"),
          },
          {
            path: "/flightSchedule/airApproachControl/newAirline",
            label: '新增航线',
            component: () => import("@/views/flightSchedule/index.vue"),
          },
          {
            path: "/flightSchedule/airlineEnquiry",
            label: '航线查询',
            component: () => import("@/views/flightSchedule/index.vue"),
          },
          {
            path: "/flightSchedule/airlineEnquiry/courseDetails",
            label: '航线详情',
            component: () => import("@/components/flightSchedule/courseDetails.vue"),
          },
        ]
      },
      {
        path: "/emergencyManagement",
        name: "emergencyManagement",
        component: () => import("@/views/emergencyManagement/index.vue"),
        redirect: '/emergencyManagement/emergency',
        children: [
          {
            path: "/emergencyManagement/emergency",
            label: '救援管理',
            component: () => import("@/views/emergencyManagement/index.vue"),
          },
        ]
      },
      {
        path: "/alarmManagement",
        name: "alarmManagement",
        component: () => import("@/views/alarmManagement/index.vue"),
        redirect: '/alarmManagement/alarm',
        children: [
          {
            path: "/alarmManagement/alarm",
            label: '告警管理',
            component: () => import("@/views/alarmManagement/index.vue"),
          },
        ]
      },
      {
        path: "/dataStatistics",
        name: "dataStatistics",
        component: () => import("@/views/dataStatistics/index.vue"),
        redirect: '/dataStatistics/aircraftStatistics',
        children: [
          {
            path: "/dataStatistics/aircraftStatistics",
            label: '飞行器统计分析',
            component: () => import("@/views/dataStatistics/index.vue"),
          },
          {
            path: "/dataStatistics/rescue",
            label: '救援统计分析',
            component: () => import("@/views/dataStatistics/index.vue"),
          },
          {
            path: "/dataStatistics/alarmStatistics",
            label: '告警统计分析',
            component: () => import("@/views/dataStatistics/index.vue"),
          },
          {
            path: "/dataStatistics/userRegister",
            label: '用户注册统计分析',
            component: () => import("@/views/dataStatistics/index.vue"),
          },
        ]
      },
	  {
		path:"/satelliteManagement",
		name:"satelliteManagement",
		component: ()=> import("@/views/satelliteManagement/index.vue"),
		redirect: '/satelliteManagement/satelliteManagement',
		children: [
		  {
		    path: "/satelliteManagement/satelliteManagement",
		    label: '山火监测',
		    component: () => import("@/views/satelliteManagement/index.vue"),
		  },
		]
	  },
      {
        path: "/userManagement",
        name: "userManagement",
        component: () => import("@/views/userManagement/index.vue"),
        redirect: '/userManagement/role',
        children: [
          {
            path: "/userManagement/role",
            label: '角色管理',
            component: () => import("@/views/userManagement/index.vue"),
            permission: 'PC-角色管理:查询',
          },
          {
            path: "/userManagement/systemUser",
            label: '用户管理',
            component: () => import("@/views/userManagement/index.vue"),
            permission: 'PC-用户管理:查询',
          },
          {
            path: "/userManagement/pilotCertification",
            label: '飞行员认证管理',
            component: () => import("@/views/userManagement/index.vue"),
          },
          {
            path: "/userManagement/enterpriseCertification",
            label: '企业认证管理',
            component: () => import("@/views/userManagement/index.vue"),
          },
        ]
      },
      {
        path: "/personalCenter",
        name: "personalCenter",
        component: () => import("@/views/personalCenter/index.vue"),
        redirect: '/personalCenter/information',
        children: [
          {
            path: "/personalCenter/information",
            label: '个人信息',
            component: () => import("@/views/personalCenter/index.vue"),
          },
          {
            path: "/personalCenter/enterprise",
            label: '企业认证',
            component: () => import("@/views/personalCenter/index.vue"),
          },
          {
            path: "/personalCenter/pilot",
            label: '飞行员认证',
            component: () => import("@/views/personalCenter/index.vue"),
          },
        ]
      },
    ]
  },
  // {
  //   path: "/dataScreen",
  //   name: "dataScreen",
  //   component: () => import("@/views/dataScreen/index.vue")
  // },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to) => {
  // 如果进入的不是登录页，要判断有没有token，如果没有token，就跳转到登录页
  const token = sessionStorage.getItem('token')
  if (to.path !== '/login') {
    
    if (!token) {
      return '/login'
    }
  } 
  // TODO
  // else if (to.path === '/login' && token){
  //   // 如果当前是登录页，并且有token的情况，直接跳转到home？
  //   return '/home'
  // }

})

export default router;
